const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressDisputedInverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-disputed-inverse",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconR-progress-disputed-inverse1",
    serifid: "iconR-progress-disputed-inverse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c0,7.727 -6.273,14 -14,14c-7.727,-0 -14,-6.273 -14,-14c0,-7.727 6.273,-14 14,-14Zm0,2.197c6.514,0 11.803,5.289 11.803,11.803c-0,6.514 -5.289,11.803 -11.803,11.803c-6.514,-0 -11.803,-5.289 -11.803,-11.803c0,-6.514 5.289,-11.803 11.803,-11.803Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.637,20.888c0,0.891 -0.722,1.612 -1.612,1.612c-0.891,0 -1.613,-0.721 -1.613,-1.612c0,-0.891 0.722,-1.613 1.613,-1.613c0.89,0.001 1.611,0.723 1.612,1.613l0,-0Zm-2.687,-4.838l-0,-7.525c-0,-0.594 0.481,-1.075 1.075,-1.075c0.593,0 1.075,0.481 1.075,1.075l-0,7.525c-0,0.594 -0.482,1.075 -1.075,1.075c-0.594,0 -1.075,-0.481 -1.075,-1.075Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressDisputedInverse);
export default __webpack_public_path__ + "static/media/iconR-progress-disputed-inverse.f48eacd5a98ec092cd732b2f8e3c4dd2.svg";
export { ForwardRef as ReactComponent };